/** SSOT for variant -> SemanticIcon name across Alert, Toast and ConfirmDialog. Consumers MUST resolve through `<SemanticIcon name={...} />`. */

import type { SemanticIconName } from '@federa/types/ui-icons';
import type { ConfirmDialogVariant } from '@federa/types/ui-confirm-dialog';
import type { FeedbackVariant } from '@federa/types/ui-feedback-variant';

/** FeedbackVariant -> banner icon. `error -> 'alert'` is deliberate: AlertCircleIcon is the banner glyph; XCircleIcon ('error') is for inline dismissal. */
export const FEEDBACK_VARIANT_ICON_NAMES: Record<FeedbackVariant, SemanticIconName> = {
	success: 'success',
	error: 'alert',
	warning: 'warning',
	info: 'info',
};

/**
 * ConfirmDialogVariant -> header icon. Distinct from FEEDBACK_VARIANT_ICON_NAMES because the GLYPH CHOICES differ, not
 * merely because the unions do: on the two members both maps carry, this one answers `warning -> 'alert'` where the
 * banner map answers `warning -> 'warning'`. Unifying the two vocabularies would therefore leave two maps standing --
 * which is why `ConfirmDialogVariant`'s leaf declines the derivation rather than chasing a fold that saves nothing.
 */
export const CONFIRM_DIALOG_VARIANT_ICON_NAMES: Record<ConfirmDialogVariant, SemanticIconName> = {
	danger: 'warning',
	warning: 'alert',
	default: 'success',
};
